import { TOfferDataRequirement } from '../../../../types';
import DocumentRequirement from '../../DocumentRequirement/DocumentRequirement';

type TProps = {
  quantifier: number;
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
const VATReturns = ({
  quantifier,
  isOptional,
  isSubmitted,
  status,
}: TProps) => {
  const quarter = quantifier / 3;
  const title =
    quarter > 1
      ? `Business VAT returns for the last ${quarter} quarters`
      : 'Business VAT returns for the last quarter';

  return (
    <DocumentRequirement
      title={title}
      documentType="vat return"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <ul>
        <li>
          We accept PDF statements downloaded from either{' '}
          <a
            href="https://www.tax.service.gov.uk/gg/sign-in?continue=/business-account/vat"
            target="_blank"
            rel="noreferrer"
          >
            the HMRC portal
          </a>{' '}
          or from your accounting software
        </li>
        <li>
          Need help? Check out our VAT return guide{' '}
          <a
            href="https://assets.ctfassets.net/835lsoe3tdrh/3GcWysGZ9ssggP8xWu2h5D/f96aae350679aeb29d3c8ab808122e6b/vat_return_instructions.pdf"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
        </li>
      </ul>
    </DocumentRequirement>
  );
};

export default VATReturns;
